import { hexToRGB } from '@repo-level/core-front';
import styled from 'styled-components/macro';

export const ScInputPromo = styled.div`
  position: relative;
  min-height: 117px;
  padding: 32px 0 0;
  margin-top: 32px;
  border-top: ${({ theme }) => `1px solid ${hexToRGB(theme.blackColor, 0.1)}`};
  .form-group {
    &__row {
      display: flex;
    }
    &__input {
      flex: auto;
      padding-right: 16px;
    }
  }
`;
